// The guest id-token is persisted under this key so the (shared-origin) confirmation app, which
// authenticates its order fetch with @noths/noths-auth, can read it. This must match the key
// @noths/noths-auth reads and writes.
export const NOTHS_ID_TOKEN_STORAGE_KEY = 'noths.idtoken';
